import React, {useState} from 'react';
import {Button, Form, Stack} from 'react-bootstrap';
import {Box, DI, FirebaseService, Loading, UrlUtils} from "shared-lib";
import {AuthConst} from "@consts";
import {useForm} from "react-hook-form";
import {useTranslation} from "react-i18next";

const firebaseService: FirebaseService = DI.get(FirebaseService);
type Props = {};
type States = { inProgress: boolean, email: string, askEmail: boolean, showSuccessMsg: boolean, showErrorMsg: boolean };

export const ResetPasswordPage: React.FunctionComponent<Props> = () => {
    const {register, handleSubmit, formState: {errors}} = useForm({shouldUnregister: true});
    const {t} = useTranslation();
    const [states, setStates] = useState({} as States);

    const onEmailSubmit = ({email}) => {
        setStates({...states, inProgress: true,});
        firebaseService.sendPasswordResetEmail(
            email,
            UrlUtils.generateAbsoluteUrl(
                AuthConst.SIGN_IN_PAGE,
                {email}
            )
        )
            .then(() => setStates({...states, showSuccessMsg: true, showErrorMsg: false, email}))
            .catch(() => setStates({...states, showSuccessMsg: false, showErrorMsg: true}));
    };

    const renderByCase = () => {
        if (states.showSuccessMsg) {
            return <Stack gap={2}>
                <p>{t('resetPassword.successMessage', {email: states.email})}</p>
                <Button href="/">{t('common.goToHomePage')}</Button>
            </Stack>;
        } else {
            return <>
                {states.showErrorMsg && <p className="mb-3 text-danger">{t('resetPassword.errorMessage')}</p>}
                <p className="mb-2">{t('resetPassword.message')}</p>
                <Form onSubmit={handleSubmit(onEmailSubmit)}>
                    <Form.Group className="mb-3">
                        <Form.Control
                            size="lg"
                            type="email"
                            placeholder={t('common.input.placeholder.email')}
                            isInvalid={!!errors.email}
                            {...register("email", {required: true})}
                        />
                        <Form.Control.Feedback type="invalid" className="text-center">
                            {t('common.input.required')}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Button variant="primary" type="submit"
                            className="w-100 btn-lg">{t('resetPassword.submit')}</Button>
                </Form>
            </>


        }
    };

    return (
        <Stack className="login-page min-vh-100 justify-content-center align-items-center bg-dark">
            <img className="login-page__logo mb-4" src="./logo_440x64.png"/>
            <Box className="login-page__form">
                <Loading show={states.inProgress}/>
                {renderByCase()}
            </Box>
        </Stack>
    );
}
